/**
 * Parameter Service
 *
 * Provides functionality for working with system parameter data.
 */

import {
    ParamCreateRequest, ParamCreateResponse, ParamDeleteRequest, ParamDeleteResponse,
    ParamGetRequest,
    ParamGetResponse,
    ParamSearchRequest,
    ParamSearchResponseItem, ParamUpdateRequest, ParamUpdateResponse
} from "../../../model";
import {CrudService} from "../../core/common/crud-service";

export class Service extends CrudService {
    /**
     * The base endpoint path for parameters
     */
    protected readonly basePath = '/api/param';
    
    /**
     * Search parameters based on criteria
     */
    async search(request: ParamSearchRequest): Promise<ParamSearchResponseItem[] | null> {
        return this.customPost<ParamSearchRequest, ParamSearchResponseItem[]>(
            'search',
            request
        );
    }

    /**
     * Get parameter details by ID, type, or code
     */
    async getParameter(request: ParamGetRequest): Promise<ParamGetResponse | null> {
        return this.customPost<ParamGetRequest, ParamGetResponse>(
            'getParam',
            request
        );
    }

    /**
     * Create new parameters
     */
    async createParameters(request: ParamCreateRequest): Promise<ParamCreateResponse | null> {
        return this.customPost<ParamCreateRequest, ParamCreateResponse>(
            'create',
            request
        );
    }

    /**
     * Update existing parameters
     */
    async updateParameters(request: ParamUpdateRequest): Promise<ParamUpdateResponse | null> {
        return this.customPost<ParamUpdateRequest, ParamUpdateResponse>(
            'update',
            request
        );
    }

    /**
     * Delete parameters
     */
    async deleteParameters(request: ParamDeleteRequest): Promise<ParamDeleteResponse | null> {
        return this.customPost<ParamDeleteRequest, ParamDeleteResponse>(
            'delete',
            request
        );
    }
}

// Export a singleton instance
export const paramService = new Service();
